import { Td } from '../../../summary/components/Td.js';
import { Tr } from '../../../summary/components/Tr.js';
import { Typography } from '../../../summary/components/Typography.js';
import { COST_APPROACH_COLUMN_WIDTHS } from '../constants.js';
import { sumPercentWidths } from '../utils/sumPercentWidths.js';

export const CostApproachSummaryTableHeader = () => (
  <Tr backgroundColor="surface2">
    <Td border="0 !important" colSpan={1} width={COST_APPROACH_COLUMN_WIDTHS[0]}>
      <Typography variant="h3">Feature</Typography>
    </Td>
    <Td
      border="0 !important"
      colSpan={7}
      width={sumPercentWidths(...COST_APPROACH_COLUMN_WIDTHS.slice(1, 4))}
    >
      <Typography variant="h3">Cost Data</Typography>
    </Td>
  </Tr>
);
